module.exports = __webpack_public_path__ + "img/collect-free-masks-1.1f899829.png";